import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-user-profile',
  templateUrl: './user-profile.component.html',
  styleUrls: ['./user-profile.component.css']
})
/** User profile page — stub component with no logic yet. */
export class UserProfileComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
